var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('EmployeesTable',{attrs:{"title":"Employees","employees":_vm.employeeData,"cid":_vm.cid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }